import {
  Trophy, Wallet, Zap, ImageIcon, Headphones, Rocket,
  UserPlus, Megaphone, TrendingUp, Dice5, Spade, LineChart,
} from "lucide-react";

export const SITE = {
  name: "TopAffiliation",
  domain: "topaffiliation.net",
  tagline: "Il primo Network di affiliazione made in Italy",
  email: "info@affiliation.bet",
  years: 25,
  partnerBrandUrl: "https://affiliation.bet/",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Chi siamo", to: "/chi-siamo" },
  { label: "Blog", to: "/blog" },
  { label: "Contatti", to: "/contatti" },
];

export const PARTNERS = [
  { name: "Betway", logo: "/brands/betway.jpg" },
  { name: "Eurobet", logo: "/brands/eurobet.jpg" },
  { name: "Sisal", logo: "/brands/sisal.jpg" },
  { name: "Snai", logo: "/brands/snai.jpg" },
];

export const AFFILIATION = {
  site: "https://affiliation.bet/",
  signup: "https://app.affiliation.bet/vapp#/sign-up",
  login: "https://app.affiliation.bet/vapp#/login",
};

export const LEGAL = {
  privacy: "https://www.iubenda.com/privacy-policy/89510172",
  termini: "https://www.iubenda.com/termini-e-condizioni/89510172",
};

export const STATS = [
  { value: 25, suffix: "+", label: "Anni sul mercato del gambling" },
  { value: 30, suffix: "gg", label: "Accredito commissioni ricorrente" },
  { value: 12, suffix: "+", label: "Brand partner selezionati" },
  { value: 100, suffix: "%", label: "Iscrizione gratuita e senza impegno" },
];

export const FEATURES = [
  {
    icon: Trophy,
    title: "I migliori bookmaker a portata di clic",
    desc: "Scegli tra i migliori siti di scommesse e casinò, italiani e stranieri. Abbiamo selezionato per te solo il meglio del mercato mondiale.",
  },
  {
    icon: Wallet,
    title: "Basse soglie di accesso e prelievo",
    desc: "Abbiamo abbassato le soglie di monetizzazione: puoi incassare subito anche i ricavi più contenuti. I grandi successi iniziano con piccoli passi.",
  },
  {
    icon: Zap,
    title: "Accredito immediato delle commissioni",
    desc: "Le commissioni ti vengono riconosciute per ogni nuova iscrizione presso gli operatori. L'accredito è immediato: vedi e incassi subito i risultati.",
  },
  {
    icon: ImageIcon,
    title: "Materiale promozionale pronto all'uso",
    desc: "Banner, link e materiale pubblicitario pronti per il tuo sito: tutti gli strumenti per promuovere i bookmaker con facilità e professionalità.",
  },
  {
    icon: Headphones,
    title: "Un supporto professionale al tuo fianco",
    desc: "Assistenza esperta e qualificata, disponibile 24 ore su 24 tramite i canali di contatto più immediati. Un supporto costante verso i tuoi successi.",
  },
  {
    icon: Rocket,
    title: "Registrazione rapida e guidata",
    desc: "Registrarsi non è mai stato così facile: pochi e semplici passaggi con una procedura guidata per entrare subito nella nostra community.",
  },
];

export const STEPS = [
  {
    icon: UserPlus,
    step: "01",
    title: "Registrati gratis",
    desc: "Crea il tuo account in meno di un minuto. Nessun costo, nessun impegno.",
  },
  {
    icon: Megaphone,
    step: "02",
    title: "Promuovi i brand",
    desc: "Scegli i migliori operatori e inserisci banner e link nel tuo sito o sui tuoi canali.",
  },
  {
    icon: TrendingUp,
    step: "03",
    title: "Guadagna ogni giorno",
    desc: "Converti il tuo traffico in commissioni con CPA e Revenue tra le più alte del web.",
  },
];

export const VERTICALS = [
  {
    icon: Dice5,
    title: "Scommesse Sportive",
    desc: "Le campagne dei migliori bookmaker italiani e internazionali, con conversioni ottimizzate.",
  },
  {
    icon: Spade,
    title: "Casinò & Gambling",
    desc: "Slot, casinò live e giochi da tavolo: i marchi più forti del settore, pronti da promuovere.",
  },
  {
    icon: LineChart,
    title: "Trading Online",
    desc: "Monetizza il traffico sul trading e sulla finanza con partner affidabili e commissioni elevate.",
  },
];
